import { makeAutoObservable, observable, action } from 'mobx'

export class ArrayStore<T> {
  data: Array<T>
  storeType: string = 'ArrayStore'
  constructor() {
    this.data = observable.array();
    makeAutoObservable(this, {
      setValue: action,
      setRow: action,
      addRow: action,
      removeRow: action
    })
  }

  setValue(list: Array<T>) {
    this.data = list
  }

  getValue() {
    return this.data
  }

  getStoreValue () {
    return this.getValue()
  }

  // dataToJson() {
  //   return this.data.map(({data})=> console.log(JSON.stringify(data)) )
  // }

  setRow(index: number = -1, item: T) {
    this.checkIsNull(index, 'setRow')
    this.data[index] = item;
  }

  addRow(item: T) {
    this.data.push(item);
  }

  removeRow(index: number) {
    this.checkIsNull(index, 'removeRow')
    this.data.splice(index, 1);
  }

  getRow(index: number) {
    this.checkIsNull(index, 'getRow')
    return this.data[index];
  }

  insertRow(index: number, row: T) {
    this.checkIsNull(index, 'insertRow')
    this.data.splice(index, 0, row)
  }

  checkIsNull(value: any, src: string = '') {
    if (value < 0 || value === undefined)
      throw new Error(`${src}${lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80044', ': 参数不允许为')}${value}`)
  }

  clear() {
    this.data = []
  }

  get size() {
    return this.data.length;
  }

}
